import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { titleCase } from 'dashboard/lib/utils/stringFormat';
import { DatabaseBusinessValidRegistrationNumberFormat } from 'dashboard/models/check';

export const computeDatabaseBusinessValidRegistrationNumberFormatMetadata = (
  check: DatabaseBusinessValidRegistrationNumberFormat,
): CheckMetadata => {
  const metadata = check.metadata;
  const matchedRegistrationNumberTypes = metadata?.['matched-registration-number-types'] || [];

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label:
          matchedRegistrationNumberTypes.length > 1
            ? 'Matched Registration Number Types'
            : 'Matched Registration Number Type',
        value:
          matchedRegistrationNumberTypes.length > 0
            ? matchedRegistrationNumberTypes.map((t) => formatRegistrationNumberType(t)).join(', ')
            : '-',
      },
    ]),
    hideIfVerificationPassed: false,
  };
};

const formatRegistrationNumberType = (registrationNumberType: string) => {
  return registrationNumberType
    .split('_')
    .map((text) => titleCase(text))
    .join(' ');
};
